import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Login } from '~ai-tutor/components/login/Login';
import { currentUserQueryOptions } from '~ai-tutor/lib/serverFunctions/auth';

const loginSearchSchema = z.object({
  silent_failed: z.boolean().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.fetchQuery(currentUserQueryOptions());

    return {
      identityType: user.authenticated ? user.identityType : undefined,
      alreadyAuthenticated: user.authenticated && (user.identityType === 'oidc' || !!user.session.token),
    };
  },
  component: Login,
});
